import { render, staticRenderFns } from "./transportType.vue?vue&type=template&id=0345d48e&"
import script from "./transportType.vue?vue&type=script&lang=js&"
export * from "./transportType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0345d48e')) {
      api.createRecord('0345d48e', component.options)
    } else {
      api.reload('0345d48e', component.options)
    }
    module.hot.accept("./transportType.vue?vue&type=template&id=0345d48e&", function () {
      api.rerender('0345d48e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/transportType.vue"
export default component.exports